export default function StatsCards({
  visitorsCount,
  servicesCount,
  projectsCount,
  messagesCount,
}) {
  const cards = [
    {
      title: "الزوار",
      value: visitorsCount,
      accent: "text-[#F28C18]",
      glow: "shadow-[#F28C18]/20",
    },
    {
      title: "الخدمات",
      value: servicesCount,
      accent: "text-[#F28C18]",
      glow: "shadow-[#F28C18]/20",
    },
    {
      title: "المشاريع",
      value: projectsCount,
      accent: "text-emerald-400",
      glow: "shadow-emerald-500/20",
    },
    {
      title: "الرسائل",
      value: messagesCount,
      accent: "text-sky-400",
      glow: "shadow-sky-500/20",
    },
  ];

  return (
    <section className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.title}
          className={`group relative overflow-hidden rounded-[28px] border border-white/10 bg-white/5 p-6 backdrop-blur-xl shadow-xl transition-all duration-300 hover:-translate-y-1 hover:border-[#F28C18]/40 hover:shadow-2xl ${card.glow}`}
        >
          {/* Glow background */}
          <div className="absolute inset-0 opacity-0 transition group-hover:opacity-100 bg-gradient-to-br from-[#F28C18]/10 to-transparent" />

          <p className="relative text-xs uppercase tracking-[0.35em] text-zinc-400">
            {card.title}
          </p>

          <div className="relative mt-6 flex items-end justify-between">
            <div>
              <p className={`text-5xl font-black text-white ${card.accent}`}>
                {card.value}
              </p>
              <p className="mt-2 text-sm text-zinc-400">إجمالي البيانات</p>
            </div>

            <span className="rounded-full border border-white/10 bg-black/20 px-4 py-2 text-xs font-black uppercase tracking-[0.3em] text-zinc-300 transition group-hover:border-[#F28C18]/40 group-hover:text-[#F28C18]">
              Live
            </span>
          </div>
        </div>
      ))}
    </section>
  );
}